module.exports = __webpack_public_path__ + "img/wave.b29098f4.png";